/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PriceOverrides } from '../../models/price-overrides';

export interface StoresStoreIdCatalogEntryOverridesCatalogEntryIdGet$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;
  catalogEntryId: string;
}

export function storesStoreIdCatalogEntryOverridesCatalogEntryIdGet(http: HttpClient, rootUrl: string, params: StoresStoreIdCatalogEntryOverridesCatalogEntryIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PriceOverrides>> {
  const rb = new RequestBuilder(rootUrl, storesStoreIdCatalogEntryOverridesCatalogEntryIdGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
    rb.path('catalogEntryId', params.catalogEntryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PriceOverrides>;
    })
  );
}

storesStoreIdCatalogEntryOverridesCatalogEntryIdGet.PATH = '/stores/{storeId}/catalog-entry-overrides/{catalogEntryId}';
